// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2oN7g","errorLogs":"EditorFooter_errorLogs__2i8UF"};